import React from "react";
import axios from "axios";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";

import { baseURLAddSwatch } from "../config/api";
async function AddSwatch(SwatchId) {
  return await new Promise((resolve, reject) => {
    axios
      .post(
        baseURLAddSwatch,
        {},
        {
          headers: authHeader(),
          params: {
            productId: SwatchId,
            count: 1,
          },
        }
      )
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              resolve(AddSwatch(SwatchId));
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
  });
}

export default AddSwatch;
